// @flow
export default {
	not_connected: {
		value: 0,
		name: 'Not Connected',
	},
	connected: {
		value: 10,
		name: 'Connected',
	},
	issues: {
		value: 20,
		name: 'Credential Issues',
	},
}
